<template>
  <div>
    <breadcrumb :crumbs="crumbs"></breadcrumb>
    <flash-message></flash-message>
    <div class="row">
      <div class="col-md-8">
        <form-description />
      </div>
      <div class="col-md-4">
        <router-link :to="'/settings/payment_settings/index'" class="ls-btn-primary">{{ $t('settings.label.buttons.config_payment_method') }}</router-link>
      </div>
    </div>
    <div class="row ls-md-margin-bottom">
      <form @submit.prevent="submitForm('formBilletSelect')" data-vv-scope="formBilletSelect">
        <div class="col-md-4">

          <label class="ls-label">
            <span class="ls-label-text col-xs-12">{{ $t('settings.main.choose_your_billet_bank') }}</span>
            <div class="ls-custom-select">
              <select v-model="selectedBilletMethod" class="ls-select">
                <option value="bb">{{ $t('settings.attributes.bb_online') }}</option>
                <option value="bradesco2">{{ $t('settings.attributes.bradesco') }}</option>
                <option value="itaushopline">{{ $t('settings.attributes.itau') }}</option>
                <option value="yapay">{{ $t('settings.attributes.yapay') }}</option>
                <option value="">{{ $t('settings.attributes.none') }}</option>
              </select>
            </div>
          </label>

          <div v-if="selectedBilletMethod">
            <label class="ls-label">
              <span class="ls-label-text col-xs-12">{{ $t('settings.main.choose_your_reprocess_billet_bank') }}</span>
              <div class="ls-custom-select">
                <select v-model="selectedReprocessBilletMethod" class="ls-select">
                  <option value="bb">{{ $t('settings.attributes.bb_online') }}</option>
                  <option value="bradesco2">{{ $t('settings.attributes.bradesco') }}</option>
                  <option value="itaushopline">{{ $t('settings.attributes.itau') }}</option>
                  <option value="yapay">{{ $t('settings.attributes.yapay') }}</option>
                  <option value="">{{ $t('settings.attributes.none') }}</option>
                </select>
              </div>
            </label>
          </div>

          <label class="ls-label">
            <span class="ls-label-text col-xs-12">{{ $t('settings.main.choose_your_card_gateway') }}</span>
            <div class="ls-custom-select">
              <select v-model="selectedCardMethod" class="ls-select">
                <option value="cielo3">{{ $t('settings.attributes.cielo') }}</option>
                <option value="getnet">{{ $t('settings.attributes.getnet') }}</option>
                <option value="yapay">{{ $t('settings.attributes.yapay') }}</option>
                <option value="">{{ $t('settings.attributes.none') }}</option>
              </select>
            </div>
          </label>

          <div v-if="selectedCardMethod">
            <label class="ls-label">
              <span class="ls-label-text col-xs-12">{{ $t('settings.main.choose_your_reprocess_card_gateway') }}</span>
              <div class="ls-custom-select">
                <select v-model="selectedReprocessCardMethod" class="ls-select">
                  <option value="cielo3">{{ $t('settings.attributes.cielo') }}</option>
                  <option value="getnet">{{ $t('settings.attributes.getnet') }}</option>
                  <option value="yapay">{{ $t('settings.attributes.yapay') }}</option>
                  <option value="">{{ $t('settings.attributes.none') }}</option>
                </select>
              </div>
            </label>
          </div>

          <label class="ls-label">
            <span class="ls-label-text col-xs-12">{{ $t('settings.main.choose_your_transfer_gateway') }}</span>
            <div class="ls-custom-select">
              <select v-model="selectedTransferMethod" class="ls-select">
                <option value="yapay">{{ $t('settings.attributes.yapay') }}</option>
                <option value="bank_redirect">{{ $t('settings.attributes.direct') }}</option>
                <option value="">{{ $t('settings.attributes.none') }}</option>
              </select>
            </div>
          </label>

          <label class="ls-label">
            <span class="ls-label-text col-xs-12">{{ $t('settings.main.choose_your_balance_method') }}</span>
            <div class="ls-custom-select">
              <select v-model="selectedBalanceMethod" class="ls-select">
                <option value="yapay">{{ $t('settings.attributes.yapay') }}</option>
                <option value="">{{ $t('settings.attributes.none') }}</option>
              </select>
            </div>
          </label>
        </div>
        <button-submit />
      </form>
    </div>
  </div>
</template>
<script>
  import { mapActions, mapGetters, mapMutations } from 'vuex'
  import Breadcrumb from 'src/app/components/shareds/Breadcrumb'
  import FormDescription from './components/FormDescription'
  import ButtonSubmit from './components/ButtonSubmit'
  import * as types from './vuex/mutations-types'

  export default {
    name: 'Settings',
    components: { Breadcrumb, FormDescription, ButtonSubmit },
    data () {
      return {
        crumbs: {
          'ico': 'ls-ico-cog',
          'section': this.$t('settings.main.select_payment_method'),
          'paths': {
            0: {
              'title': this.$t('settings.main.setup'),
              'path': ''
            }
          }
        }
      }
    },
    methods: {
      ...mapActions(['editPaymentMethodConfigs', 'loadBilletMethod', 'loadReprocessBilletMethod', 'loadCardMethod', 'loadReprocessCardMethod', 'updateBillingSetting', 'loadTransferMethod', 'loadBalanceMethod']),
      ...mapMutations(['addFlash', 'clearFlash']),
      submitForm () {
        this.clearFlash()
        if (this.validateMethods()) {
          let billetMethodParams = { id: 7, value: this.selectedBilletMethod }
          let cardMethodParams = { id: 8, value: this.selectedCardMethod }
          let transferMethodParams = { id: 15, value: this.selectedTransferMethod }
          let reprocessBilletParams = { id: 13, value: this.selectedReprocessBilletMethod }
          let reprocessCardParams = { id: 14, value: this.selectedReprocessCardMethod }
          let balanceMethodParams = { id: 17, value: this.selectedBalanceMethod }

          this.$loader.show()

          this.updateBillingSetting(billetMethodParams).then(() => this.updateBillingSetting(reprocessBilletParams))
          this.updateBillingSetting(cardMethodParams).then(() => this.updateBillingSetting(reprocessCardParams))
          this.updateBillingSetting(transferMethodParams)
          this.updateBillingSetting(balanceMethodParams)
          this.afterUpdateAllSettings()
        }
      },
      afterUpdateAllSettings () {
        this.$loader.hide()
        this.addFlash({ message: this.$t('settings.label.saved_payment_methods'), type: 'ls-alert-success' })
      },
      getPaymentMethods () {
        this.$loader.show()
        this.loadBilletMethod()
        this.loadReprocessBilletMethod()
        this.loadTransferMethod()
        this.loadCardMethod()
        this.loadReprocessCardMethod()
        this.loadBalanceMethod({ id: 17 }).then(this.afterLoadBothSettings)
      },
      afterLoadBothSettings () {
        this.$loader.hide()
      },
      validateMethods () {
        let billetMethods = [this.selectedBilletMethod, this.selectedReprocessBilletMethod]
        let cardMethods = [this.selectedCardMethod, this.selectedReprocessCardMethod]
        let valid = true

        if (!billetMethods.includes('') && (this.selectedBilletMethod === this.selectedReprocessBilletMethod)) {
          this.addFlash({ message: this.$t('settings.label.messages.duplicate_billet_methods'), type: 'ls-alert-danger' })
          valid = false
        }
        if (!cardMethods.includes('') && (this.selectedCardMethod === this.selectedReprocessCardMethod)) {
          this.addFlash({ message: this.$t('settings.label.messages.duplicate_card_methods'), type: 'ls-alert-danger' })
          valid = false
        }
        return valid
      }
    },
    computed: {
      ...mapGetters(['billetMethod', 'cardMethod', 'transferMethod', 'reprocessBilletMethod', 'reprocessCardMethod', 'reprocessTransferMethod', 'balanceMethod']),
      selectedBilletMethod: {
        get () {
          return this.billetMethod || ''
        },
        set (value) {
          this.$store.commit(types.billetMethod, value)
        }
      },
      selectedReprocessBilletMethod: {
        get () {
          return this.reprocessBilletMethod || ''
        },
        set (value) {
          this.$store.commit(types.reprocessBilletMethod, value)
        }
      },
      selectedCardMethod: {
        get () {
          return this.cardMethod || ''
        },
        set (value) {
          this.$store.commit(types.cardMethod, value)
        }
      },
      selectedReprocessCardMethod: {
        get () {
          return this.reprocessCardMethod || ''
        },
        set (value) {
          this.$store.commit(types.reprocessCardMethod, value)
        }
      },
      selectedTransferMethod: {
        get () {
          return this.transferMethod || ''
        },
        set (value) {
          this.$store.commit(types.transferMethod, value)
        }
      },
      selectedBalanceMethod: {
        get () {
          return this.balanceMethod || ''
        },
        set (value) {
          this.$store.commit(types.balanceMethod, value)
        }
      }
    },
    mounted () {
      this.getPaymentMethods()
    }
  }
</script>
<style>

</style>



// WEBPACK FOOTER //
// PaymentSettings.vue?5fcf5552